/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import AtomicSDK from '@atomic.io/action-cards-web-sdk';
import { Capacitor } from '@capacitor/core';
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';

export function handleRequestATT() {
  if (Capacitor.getPlatform() === 'ios') {
    AppTrackingTransparency.requestPermission().then((status) => {
      AtomicSDK.updateUser({
        profile: {
          flp_att_enabled: status.status,
        },
      });
    });
  }
}
